import { useContext } from 'react';

import {
  defaultRoutes,
  internationalRoutes,
  localRoutes,
  usaRoutes,
} from '../constants/routes';
import PortalContext from '../context/portal/context';
import { Portal } from '../enums/portal.enum';

export function usePortalRoutes() {
  const { selectedPortal } = useContext(PortalContext);
  const isLocalPortal = selectedPortal === Portal.PHILIPPINES;
  const isInternationalPortal = selectedPortal === Portal.INTERNATIONAL;
  const isUSAPortal = selectedPortal === Portal.USA;

  const getPortalRoutes = () => {
    if (isLocalPortal) {
      return localRoutes;
    }
    if (isInternationalPortal) {
      return internationalRoutes;
    }
    if (isUSAPortal) {
      return usaRoutes;
    }
    return defaultRoutes;
  };

  return {
    selectedPortal,
    getPortalRoutes,
  };
}
